import React from 'react';
import { cn } from '@/lib/utils';
import './styles/checkbox.css';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ checked = false, onCheckedChange, className, disabled, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onCheckedChange?.(e.target.checked);
      onChange?.(e);
    };

    return (
      <div className={cn('inline-flex items-center gap-2', className)}>
        {/* `onChange` is destructured out above and re-applied through
            handleChange. Leaving it in `props` would let the spread overwrite
            handleChange and silently drop onCheckedChange. */}
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          className="sr-only peer"
          {...props}
          onChange={handleChange}
        />
        <div
          className={cn(
            'form-checkbox-box',
            checked ? 'form-checkbox-box-checked' : 'form-checkbox-box-unchecked',
            'peer-focus:shadow-ring-focus',
            disabled && 'form-checkbox-disabled'
          )}
        >
          <svg
            className={cn('form-checkbox-icon', checked ? 'opacity-100' : 'opacity-0')}
            viewBox="0 0 12 12"
          >
            <polyline points="2,6 5,9 10,3" />
          </svg>
        </div>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
